'use client'
// Filter bar for SEO landing pages. Updates URL query params (sort/beds/min/max),
// resetting ?page — the server component re-queries from the URL, so results stay
// crawlable while the controls are interactive. Layered on top of the slug's preset.
import { useRouter, usePathname, useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

const PRICE_MIN = [
  ['', 'Min price'], ['1000000', '₱1M'], ['5000000', '₱5M'], ['10000000', '₱10M'],
  ['20000000', '₱20M'], ['50000000', '₱50M'],
]
const PRICE_MAX = [
  ['', 'Max price'], ['5000000', '₱5M'], ['10000000', '₱10M'], ['20000000', '₱20M'],
  ['50000000', '₱50M'], ['100000000', '₱100M'],
]

export default function LandingFilters() {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const update = useCallback(
    (key: string, value: string) => {
      const q = new URLSearchParams(searchParams.toString())
      if (value) q.set(key, value)
      else q.delete(key)
      q.delete('page') // any filter change resets to page 1
      const s = q.toString()
      router.push(s ? `${pathname}?${s}` : pathname, { scroll: false })
    },
    [router, pathname, searchParams]
  )

  const sel =
    'h-10 rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-800 focus:border-[#d60500] focus:outline-none'
  const cur = (k: string) => searchParams.get(k) || ''

  return (
    <div className="flex flex-wrap items-center gap-3">
      <select className={sel} value={cur('sort')} onChange={(e) => update('sort', e.target.value)} aria-label="Sort">
        <option value="">Sort: Price (high → low)</option>
        <option value="price_asc">Price (low → high)</option>
        <option value="newest">Newest first</option>
      </select>
      <select className={sel} value={cur('beds')} onChange={(e) => update('beds', e.target.value)} aria-label="Bedrooms">
        <option value="">Any beds</option>
        <option value="1">1 bedroom</option>
        <option value="2">2 bedrooms</option>
        <option value="3">3 bedrooms</option>
        <option value="4">4 bedrooms</option>
      </select>
      <select className={sel} value={cur('min_price')} onChange={(e) => update('min_price', e.target.value)} aria-label="Minimum price">
        {PRICE_MIN.map(([v, l]) => (
          <option key={v} value={v}>{l}</option>
        ))}
      </select>
      <select className={sel} value={cur('max_price')} onChange={(e) => update('max_price', e.target.value)} aria-label="Maximum price">
        {PRICE_MAX.map(([v, l]) => (
          <option key={v} value={v}>{l}</option>
        ))}
      </select>
    </div>
  )
}
